import commonUtils from "../../utils/common.utils";

export default class OrderSpec {
    constructor(data) {
        this.id = commonUtils.generateId();
        this.productSpec = data.productSpec;
        this.subSpecOptionSelectCount = data.subSpecOptionSelectCount;
        this.mustHave = data.mustHave;
        this.frontEndDisplayName = data.frontEndDisplayName;
        this.isSingleSelection = data.isSingleSelection;
        this.multiSelectionMin = data.multiSelectionMin;
        this.multiSelectionMax = data.multiSelectionMax;
        this.allowSelectManyTimes = data.allowSelectManyTimes;
        this.addSortingOrder()
        this.deleteSubSpecID(data)
    }

    addSortingOrder() {
        this.productSpec.sortingOrder = -1
    }

    deleteSubSpecID(data) {
        delete data.subSpecID
    }
}